import React, { useState } from "react";
import { SelectSectionButton } from "../../../shared/ui";
import TextFieldWithButtons from "../../../shared/ui/TextFieldWithButtons/TextFieldWithButtons";
import { SectionWidth } from "../../../../shared";
import shallow from "zustand/shallow";
import styles from "./addOffsetSectionButton.module.scss";
import { useShelvingStore } from "../../../../store/useShelvingStore";

const AddOffsetSectionButton = () => {
    const [offsetBetweenSections, setOffsetBetweenSections] = useState<number>(600);


    const addSectionInShelf = useShelvingStore(state => state.addSectionInShelving, shallow);
    const onSelectSection = (value: SectionWidth, isIndent = false) => {
        addSectionInShelf(value, isIndent);
    };
    return (
        <SelectSectionButton onClick={() => onSelectSection(offsetBetweenSections, true)}>
            <div className={styles.buttonContainer}>
                <div>Добавить отступ</div>
                <div className={styles.inputWithUnit}>
                    <TextFieldWithButtons
                        style={{ width: "100%", marginRight: 10 }}
                        inputProps={{
                            style: { padding: 0, marginRight: 0 },
                        }}
                        isEval={false}
                        hideButtons={true}
                        autoFocus={false}
                        objValue={offsetBetweenSections}
                        setObjValue={setOffsetBetweenSections}
                        min={200}
                        max={1200}
                    />
                    <div>мм</div>
                </div>
            </div>
        </SelectSectionButton>
    );
};

export default AddOffsetSectionButton;
